import { render } from "./InvitacionNueva.vue?vue&type=template&id=309eb291"
import script from "./InvitacionNueva.vue?vue&type=script&lang=js"
export * from "./InvitacionNueva.vue?vue&type=script&lang=js"

import "./InvitacionNueva.vue?vue&type=style&index=0&id=309eb291&lang=css"

import exportComponent from "C:\\Users\\Desarrollo\\Documents\\Inventarios 2.0\\Technosoft.Inventarios.v2\\Technosoft.Inventarios.v2.UI.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__